import { State } from 'modules';

export const loadTenantsPending = (state: State) =>
  state.tenant.loadTenantsPending;
export const loadTenantPending = (state: State) =>
  state.tenant.loadTenantPending;

export const tenant = (state: State) => state.tenant.tenant;

export const loadMoreTenantsPending = (state: State) =>
  state.tenant.loadTenantsPending;
export const allTenantsLoaded = (state: State) =>
  state.tenant.allTenantsLoaded;
export const tenantList = (state: State) =>
  state.tenant.tenantsList;
export const tenantFilters = (state: State) => state.tenant.filters;
export const tenantsListLoaded = (state: State) =>
  state.tenant.tenantsListLoaded;

export const updateTenantPending = (state: State) =>
  state.tenant.updateTenantPending;

export const createTenantPending = (state: State) =>
  state.tenant.createTenantPending;
